import { MantineSize, Select } from "@mantine/core"

type Props = {
  value: string | null | undefined
  onChange: (v: string | null) => void
  error?: React.ReactNode
  label?: React.ReactNode
  placeholder: string
  disabled?: boolean
  noError?: boolean
  options: { value: string; label: string }[]
  clearable?: boolean
  required?: boolean
  searchable?: boolean
  onSearchChange?: (e: string) => void | any
  filter?: any
  itemComponent?: any
  maxDropdownHeight?: any
  size?: MantineSize
}

export function SelectItemField({
  value,
  onChange,
  error,
  label,
  placeholder,
  noError = false,
  options = [],
  disabled = false,
  clearable = false,
  required = false,
  searchable = false,
  onSearchChange = () => {},
  itemComponent = false,
  maxDropdownHeight = false,
  size,
}: Props) {
  const uniqueOptions = Array.from(new Map(options.map((item) => [item.value, item])).values())

  return (
    <Select
      size={size}
      searchable={searchable}
      label={label}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onSearchChange={(query) => {
        const selectedItem = uniqueOptions.find((item) => item.value === value)
        if (onSearchChange) {
          onSearchChange(selectedItem && query === selectedItem.label ? "" : query)
        }
      }}
      onChange={onChange}
      error={error}
      required={required}
      clearable={clearable}
      data={uniqueOptions}
      style={{ flex: 1 }}
      styles={{
        error: { display: noError ? "none" : "block" },
        wrapper: { marginBottom: noError && error ? 0 : undefined },
      }}
      renderOption={itemComponent && itemComponent}
      maxDropdownHeight={maxDropdownHeight && maxDropdownHeight}
    />
  )
}
